import { Cover, Stack } from 'design-system'

import { ShareLinkWrapper } from './wrapper'

export const ShareLinkError = () => {
  return (
    <Cover fullSize className="px-4">
      <ShareLinkWrapper>
        <Stack gap={4}>
          <h2 className="text-base">Failed To Fetch Data</h2>
          <div>
            We failed to fetch the neccessary data to load this page. Please
            refresh this page, or contact support{' '}
            <a href="mailto:support@yellowdig.com">support@yellowdig.com</a>
          </div>
        </Stack>
      </ShareLinkWrapper>
    </Cover>
  )
}
